// @flow

import pagofacilSrc from './pagofacil.svg';
import rapipagoSrc from './rapipago.svg';

export function getBrandSource(brandName: string): string {
  switch (brandName) {
    case 'pagofacil':
      return pagofacilSrc;
    case 'rapipago':
      return rapipagoSrc;
    default:
      throw new Error(`Brand "${brandName} not supported"`);
  }
}
